export const STATUS_PAYMENT_MESSAGES = {
  creating: 'Платеж в процессе создания. Подождите немного',
  pending: 'Платеж в процессе создания. Подождите немного',
  success: 'Платеж создан. Вы будете переведены на страницу оплаты',
  error: 'Создать платеж не получилось. Пожалуйста, повторите попытку',
  canceled: 'Создать платеж не получилось. Пожалуйста, повторите попытку',
  expired: 'Создать платеж не получилось. Пожалуйста, повторите попытку',
  exhausted:
    'Получить ответ от сервера не удалось. Попробуйте перезагрузить страницу или обратиться в поддержку',
}
